import accounting from "accounting-js";
import store from "../store";

export const filterMixin = {
  filters: {
    money_format: function (value) {
      return accounting.formatNumber(value, {
        symbol: "R$",
        thousand: ".",
        decimal: ",",
        format: "%s %v"
      });
      // accounting.settings.symbol = "Ξ ";
      // return accounting.formatMoney(value);
    },
    date_format: function (value, with_time = false) {
      let options = {};
      if (!with_time) {
        options = {year: "numeric", month: "numeric", day: "numeric"};
      } else {
        options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric"
        };
      }
      return new Date(value).toLocaleDateString("en-US", options);
    },
    round_number: function (value) {
      return accounting.toFixed(value, 4);
    },
    format_cpf: function(value){
      value = value.replace(/\D+/g, '');
      if(value.length === 14){
        return value.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
      } else {
        return value.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
      }
    },
    format_phone: function(value){
      value = value.replace(/\D+/g, '');
      return value.replace(/(\w{2})(\w{2})(\w{5})(\w)/, '+$1 $2 $3 $4');
    },
    format_boleto: function(value){
      value = value.replace(/\D+/g, '');
      return value.replace(/(\w{5})(\w{5})(\w{5})(\w{6})(\w{5})(\w{6})(\w{1})(\w{14})/, '$1.$2 $3.$4 $5.$6 $7 $8');
    },
    truncate: function (value, number) {
      if (value.length > number) {
        return value.substr(0, number) + '...';
      } else {
        return value
      }
    },
    country_code_to_name: function (code) {
      if(code && store.getters.GetCountryDropDown.length) {
        return store.getters.GetCountryDropDown.filter(country => country.code === code.toUpperCase())[0].name;
      }
    },
  },
};
